import React, { useState } from 'react';

const CMD = 'cd ~/Downloads/velinx-crm/agent && python bridge.py';

export default function Scraper() {
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(CMD).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div>
      <div className="page-header">
        <div className="page-eyebrow">▸ tools / scraper</div>
        <div className="page-title">scraper</div>
        <div className="page-divider" />
      </div>

      <div className="form-section">
        <div className="form-section-title">start the bridge</div>
        <p style={{ fontSize: 12, color: 'var(--smoke)', marginBottom: '1rem', lineHeight: 1.6 }}>
          run this in a terminal to start the local scraper bridge on port 3001.
        </p>
        <div className="cmd-box">
          <code>{CMD}</code>
          <button className="copy-btn" onClick={copy}>
            {copied ? 'copied!' : 'copy'}
          </button>
        </div>
      </div>

      <div className="form-section">
        <div className="form-section-title">open scraper</div>
        <p style={{ fontSize: 12, color: 'var(--smoke)', marginBottom: '1rem', lineHeight: 1.6 }}>
          once the bridge is running, open the scraper ui to configure and launch.
        </p>
        <a
          href="http://localhost:3001"
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary"
          style={{ textDecoration: 'none' }}
        >
          open scraper ▸
        </a>
      </div>
    </div>
  );
}
